import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-yellow bg-brand-blue" data-id="element-112" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-113" data-mp="icorj26lvwc3">
        <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.16em] text-brand-yellow" data-id="element-114" data-mp="mds8xt4ay0ff">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1 font-display text-2xl uppercase leading-tight text-white sm:text-4xl" data-id="element-115" data-mp="wczjk8jnjgyu">
          Comienza hoy desde cero y avanza a tu ritmo.
        </h2>

        <Reveal className="mt-3 rounded-xl border-4 border-dashed border-brand-yellow bg-white p-4" data-id="element-116" data-mp="2y3uivad2hyab">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-lg" data-id="element-117" data-mp="12o1vx48zn48k">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-118" data-mp="sxp2emj740qa" />
          </a>
          <p className="mt-2.5 text-[0.8rem] font-extrabold uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-119" data-mp="ouamdvv9bkcu">
            {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 text-[0.75rem] font-extrabold uppercase text-brand-carbon" data-id="element-120" data-mp="1gokyvwyljk3v">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-[0.75rem] text-brand-muted" data-id="element-121" data-mp="1cniyvdwuv40u">
            🎁 Bonos valorados en{' '}
            <span className="font-bold text-brand-carbon line-through decoration-red-600" data-id="element-122" data-mp="17oxvx6q7y68p">
              {BONUS_VALUE}
            </span>
          </p>

          <p className="mt-2 inline-block rounded bg-red-600 px-2.5 py-0.5 text-[0.62rem] font-extrabold uppercase tracking-wide text-white" data-id="element-123" data-mp="3sbsorns9fz5v">
            🔥 Oferta especial
          </p>

          <p className="mt-1 font-display text-5xl leading-none text-brand-navy sm:text-6xl" data-id="element-124" data-mp="2nydxris54yc">
            Hoy: {PRICE}
          </p>
          <p className="mt-1 text-[0.7rem] font-semibold text-brand-muted" data-id="element-125" data-mp="3kt1m5l41lx2z">
            Pago único • Sin mensualidades • Acceso Digital
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-126" data-mp="3b2zy2tboweo2">
            🚀 Sí, quiero el sistema completo por {PRICE}
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.68rem] font-semibold text-brand-muted" data-id="element-127" data-mp="3fwb6gyw5h3i3">
            <span className="flex items-center gap-1" data-id="element-128" data-mp="363voi1kusex7">
              <ZapIcon size={12} className="text-brand-blue" data-id="element-129" data-mp="364oqyqcs4i9j" />
              Acceso Inmediato
            </span>
            <span data-id="element-130" data-mp="2s702z9nf0v09">•</span>
            <span className="flex items-center gap-1" data-id="element-131" data-mp="2x3gzar4rqfof">
              <ShieldCheckIcon size={12} className="text-brand-blue" data-id="element-132" data-mp="2x2xgl87ann9c" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}